( function () {
	'use strict';

	function attachPdfService ( $window, load ) {
		var pdfmakeReady = false;

		function hasPdfMake () {
			return pdfmakeReady && $window.pdfMake;
		}

		load.loadScript( '/external-component/pdfmake/pdfmake.min.js' ).then( function () {
			pdfmakeReady = true;

			load.loadScript( '/external-component/pdfmake/pdf-vfs.js' );
			load.loadScript( '/external-component/pdfmake/lodash.min.js' );
		} );

		return {
			'hasPdfMake' : hasPdfMake
		};
	}

	attachPdfService.$inject = [ '$window', 'angularLoad' ];

	angular
		.module( 'app.components' )
		.factory( 'attachPdfService', attachPdfService );
} )( );
